<template>
	<div id="qvo-app">
		<titlebar />
		<notificationCenter />
		<navbar />
		<main id="content" class="configuration">
			<h1>Configuration</h1>
			<tab-group class="account-body" v-model="tab">
				<template v-if="activeTenantId !== 'master'">
					<tab-item title="Active" class="config-active-tab">
						<div
							class="config-action-bar"
							v-if="configProfile.isLive"
						>
							<div class="config-active-profile">
								<p>Active Profile</p>

								<p class="config-active-profile-id">
									{{ configProfile.profileLabel }}
								</p>
							</div>
							<div class="explore-configs-button">
								<v-btn
									outlined
									:to="{
										name: 'Configuration Explorer',
										params: { step: 'select-profile' },
									}"
									>Explore Configurations</v-btn
								>
							</div>
						</div>
						<div v-else>
							<v-skeleton-loader
								type="heading"
								style="margin-left: 2em"
							></v-skeleton-loader>
						</div>
						<!-- Likely to change in the future -- currently just waiting for timeout and profileId-->
						<div
							class="configuration-read-only-data"
							v-if="
								configProfile.isLive &&
								displayData
							"
						>
							<v-data-table
								:hide-default-footer="true" 
								:headers="headers"
								:items="configurationDetails"
								item-key="id"
								:single-expand="singleExpand"
								:expanded.sync="expanded"
								show-expand
								class="config-data-table no-zebra"
								>

									<template v-slot:expanded-item="{ headers, item }">
										<td :colspan="headers.length">
											<initialDecision v-if="item.id === 1 && !hideInitialDecisions" :isModifiable="false" />
											<configurationTable v-else-if="item.id  === 2" :isReadOnly="true" />
											<decisionMatrix v-else :readOnly="true" />
										</td>
									</template>
								</v-data-table>
						</div>
						<div v-else class="configuration-read-only-data">
							<v-skeleton-loader type="article"></v-skeleton-loader>
							<v-skeleton-loader type="table"></v-skeleton-loader>
							<v-skeleton-loader type="article"></v-skeleton-loader>
						</div>
					</tab-item>
					<tab-item title="History">
						<div v-if="!viewHistoryDetails">
							<historicalProfileTable @viewDetails="viewDetails" />
							<historicalAuditLog />
						</div>
						<div v-else>
							<back-nav-btn :action="backToProfileHistory" class="configuration-history-back">Back to Live Profile History</back-nav-btn>
							<div v-if="configProfile.profileId !== '' && !configProfile.isLive && configProfile.profileLabel !== undefined">
								<div class="configuration-history-title-bar">
									<h2 id="history-profile-label">{{ configProfile.profileLabel }}</h2>
									<label for="history-profile-label" class="history-profile-last-active">Last Active: {{ deployEndDateTime }}</label>
								</div>

								<!-- profile history stats -->
								<profileHistoryStats />
								
								<v-data-table
								:hide-default-footer="true" 
								:headers="headers"
								:items="configurationDetails"
								item-key="name"
								:single-expand="singleExpand"
								:expanded.sync="expanded"
								show-expand
								class="config-data-table no-zebra">

									<template v-slot:expanded-item="{ headers, item }">
										<td :colspan="headers.length">
											<initialDecision v-if="item.id === 1 && !hideInitialDecisions" :isModifiable="false" />
											<div v-else-if="item.id === 2">
											<configurationTable :isReadOnly="true" />
											</div>
											<decisionMatrix v-else :readOnly="true" />
										</td>
									</template>
								</v-data-table>

								<!-- profile history audit log -->
								<historicalAuditLog :profileLevel="true" class="profile-history-audit-log"/>
									
							</div>
							<div v-else class="configuration-read-only-data">
								<v-skeleton-loader type="article"></v-skeleton-loader>
								<v-skeleton-loader type="table"></v-skeleton-loader>
								<v-skeleton-loader type="article"></v-skeleton-loader>
							</div>
						</div>
					</tab-item>
				</template>
				<template v-else>
					<tab-item title="Profiles" class="config-active-tab">
						<div
							class="config-action-bar"
							v-if="configProfile.TenantId === 'master'"
						>
							<div class="config-active-profile">
								<p>Default Profile</p>

								<p class="config-active-profile-id">
									{{ configProfile.profileLabel }}
								</p>
							</div>
							<div class="explore-configs-button">
								<v-btn
									outlined
									:to="{
										name: 'Configuration Explorer',
										params: { step: 'select-profile' },
									}"
									>Explore Configurations</v-btn
								>
							</div>
						</div>
						<div v-else>
							<v-skeleton-loader
								type="heading"
								style="margin-left: 2em"
							></v-skeleton-loader>
						</div>
						<!-- Likely to change in the future -- currently just waiting for timeout and profileId-->
						<div
							class="configuration-read-only-data"
							v-if="
								configProfile.TenantId === 'master' &&
								displayData
							"
						>
							<v-data-table
								:hide-default-footer="true" 
								:headers="headers"
								:items="configurationDetails"
								item-key="id"
								:single-expand="singleExpand"
								:expanded.sync="expanded"
								show-expand
								class="config-data-table no-zebra"
								>

									<template v-slot:expanded-item="{ headers, item }">
										<td :colspan="headers.length">
											<initialDecision v-if="item.id === 1 && !hideInitialDecisions" :isModifiable="false" />
											<configurationTable v-else-if="item.id  === 2" :isReadOnly="true" />
											<decisionMatrix v-else :readOnly="true" />
										</td>
									</template>
								</v-data-table>
						</div>
						<div v-else class="configuration-read-only-data">
							<v-skeleton-loader type="article"></v-skeleton-loader>
							<v-skeleton-loader type="table"></v-skeleton-loader>
							<v-skeleton-loader type="article"></v-skeleton-loader>
						</div>
					</tab-item>
					<tab-item title="Factors &amp; Decisions">
						<factorsAndDecisions v-if="!viewInitialDecisionDetails && !viewFactorDetails" @viewInitialDecision="viewInitialDecision" @viewFactor="viewFactor"/>
						<initialDecisionDetails v-else-if="viewInitialDecisionDetails" :decision="initialDecisionMetaDataDetails" @backToInitialDecisionPool="backToInitialDecisionPool"/>
						<factorDetails v-else :factor="factorMetaDataDetails" @backToEvaluationFactorPool="backToEvaluationFactorPool"/>
					</tab-item>
				</template>
			</tab-group>
		</main>

		<footnote />
	</div>
</template>

<script>
	/**
	 * @fileoverview configuration.vue is the landing page for the application. It displays the live/default master profile 
	 * details, as well as historical data and application metadata. It relies on vuex to map the state variables from the store files.
	 * 
	 * @components
	 * 		configurationTable - flat list of groups and factors used in the profile's factor configuration,
	 * 		decisionMatrix -  3x3 matrix with friendly fraud on the Y axis and true fraud on the X axis, 
	 * 		historicalProfileTable - data table of all the previously deployed profiles for the active tenant,
	 *		historicalAuditLog - tenant level audit log of profile actions: create, update, delete, and deploy;
	 *		profileHistoryStats - selected historical profile statistics,
	 *		factorsAndDecisions - factors and decisions meta data list,
	 *		initialDecisionDetails - inital decision meta data details,
	 *		factorDetails - factor meta data details,
	 *		initialDecision - not currently used - draggable initial decision display for individual profiles,
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */

	import configurationTable from "@/components/configuration-table";
	import decisionMatrix from "@/components/configuration-explorer/decision-matrix";
	import { mapState } from "vuex";

	export default {
		name: "configuration",
		components: {
			configurationTable,
			decisionMatrix,
			// Lazy load components with conditional displays
			historicalProfileTable: () =>
				import("@/components/configuration-history/historical-profile-table"),
			historicalAuditLog: () =>
				import("@/components/configuration-history/historical-audit-log"),
			profileHistoryStats: () =>
				import("@/components/configuration-history/profile-history-stats"),
			factorsAndDecisions: () => 
				import("@/components/admin/factors-and-decisions"),
			initialDecisionDetails: () =>
				import("@/components/admin/initial-decision-details.vue"),
			factorDetails: () =>
				import("@/components/admin/factor-details.vue"),
			initialDecision: () =>
				import("@/components/configuration-explorer/initial-decision.vue"),
		},
		computed: {
			...mapState({
				configProfile: (state) => state.config.configProfile,
				activeTenantId: (state) => state.account.activeTenantId,
				initialDecisionMetaDataDetails: (state) => state.config.initialDecisionMetaDataDetails,
				factorMetaDataDetails: (state) => state.config.factorMetaDataDetails,
				profileList: (state) => state.config.profileList,
				hideInitialDecisions: (state) => state.config.hideInitialDecisions
			}),
		},
		watch: {
			/**
			 * Operates on an instance of the Configuration view. This function retrieves data and
			 * pushes the correct path onto the router based on the selected tab.
			 */
			async tab() {
				let payload = {
						profileId: this.configProfile.profileId,
						tenantId: this.activeTenantId,
					};

				// refresh on history tab
				if (this.$route.name === "Configuration History" && this.refreshFlag) {
					this.refreshFlag = false;
					this.tab = "history";

					if (this.$route.params.id !== undefined) {
						this.viewHistoryDetails = true;
						this.historyProfileId = this.$route.params.id;
						this.parseLastActive(this.$route.params.deployEndDateTime);
					}			
				}
				// Change URL for active tab
				else if (this.tab === "active" && this.$route.name === "Configuration History") {
					if (!this.configProfile.isLive) {
						let liveProfile = this.profileList.find(profile => profile.isLive === true);
						payload.profileId = liveProfile.profileId;

						this.$store.dispatch("retrieveProfile", payload);
					}

					this.$router.push({name: "Configuration"});
				}

				// Change URL for history tab
				else if (this.tab === "history") {
					if (this.viewHistoryDetails) {
						if (this.configProfile.isLive) {
							payload.profileId = this.historyProfileId;
							await this.$store.dispatch("retrieveProfile", payload);
							await this.$store.dispatch("retrieveProfilePerformance", payload);

							if (this.$route.params.id === undefined) {
								let deployEnd = this.deployEndDateTime.replace(" ", "_");
								this.$router.push({name: "Configuration History", params: {id: this.historyProfileId, deployEndDateTime: deployEnd}});
							}
						}
					}

					else if (this.$route.name !== "Configuration History") {
						this.$router.push({name: "Configuration History"});
					}	
					
				}

				// handle profiles and factors & decisions tabs
				else {
					// refresh on factors & decisions tab
					if (this.$route.name === "Configuration Factors & Decisions" && this.refreshFlag) {
						this.refreshFlag = false;

						if (this.$route.params.id !== undefined && this.$route.params.type !== undefined) {
							if (this.$route.params.type === "decision") {
								let decisionPayload = {
									tenantId: this.activeTenantId,
									initialDecisionConfigId: this.$route.params.id
								};
								// retrieve initial decision meta data
								this.$store.dispatch("retrieveInitialDecisionMetaData", decisionPayload);
								this.viewInitialDecisionDetails = true;
							}
							else {
								let factorPayload = {
									tenantId: this.activeTenantId,
									factorId: this.$route.params.id
								};
								// retrieve factor meta data
								this.$store.dispatch("retrieveFactorMetaData", factorPayload);
								this.viewFactorDetails = true;
							}
						}

						this.tab = "factors-&-decisions";
					}
					// Change URL for factors & decisions tab
					else if (this.tab === "factors-&-decisions") {
						if (this.viewFactorDetails) {
							if (this.$route.params.id === undefined) {
								this.$router.push({name: "Configuration Factors & Decisions", params: {type: "factor", id: this.factorMetaDataDetails.factorId}});
							}					
						} else if (this.viewInitialDecisionDetails) {
							if (this.$route.params.id === undefined) {
								this.$router.push({name: "Configuration Factors & Decisions", params: {type: "decision", id: this.initialDecisionMetaDataDetails.initialDecisionConfigId}});
							}
						}
						else if (this.$route.name !== "Configuration Factors & Decisions"){
							this.$router.push({name: "Configuration Factors & Decisions"});
						}
					}
					// Change URL for profiles tab
					else if (this.tab === "profiles" && this.$route.name !== "Configuration") {
						this.$router.push({name: "Configuration"});
					}	
				}

				this.refreshFlag = false;

				// NOTE: temporarily hiding initial decisions
				this.expanded = [
					//{name:'Initial Decisons', id: 1},
					{name:'Evaluation Factors', id: 2},
					{name:'Evaluation Decisions', id: 3}];
				
			}
		},
		data() {
			return {
				tab: "",	// current tab
				refreshFlag: true,	// true if a refresh has just occured, false otherwise
				displayData: false,	// display data after a set amount of time
				viewHistoryDetails: false,	// display a profile's historical data
				viewInitialDecisionDetails: false, 	// display initialDecisionDetails component
				viewFactorDetails: false,	// display factorDetails component
				historyProfileId: "",	// historical profile Id
				deployEndDateTime: "",	// last active date time for profile
				/** 
				* profile details
				* NOTE: temporarily hiding initial decisions
				*/
				configurationDetails: [
					//{name:'Initial Decisons', id: 1},
					{name:'Evaluation Factors', id: 2},
					{name:'Evaluation Decisions', id: 3}
				],
				singleExpand: false,	// false - allow multiple expands at once
				expanded: [],	// list of expanded profile items
				/**
				* headers for data tables
				*/
				headers: [
					{
						align: 'start',
						sortable: false,
						value: "name"
					}, 
					]
			};
		},
		/**
		* Created lifecycle hook
		* Retrieve the overallConfig for the active tenant
		*/
		async created() {
			let payload = {
				tenantId: this.activeTenantId,
				route: this.$route
			};

			await this.$store.dispatch("retrieveOverallConfig", payload);
		},
		/**
		* Mounted lifecycle hook
		* Set displayData to true after 2 minutes
		*/
		mounted() {
			this.timeout = setTimeout(() => (this.displayData = true), 2000);
		},
		methods: {
			/**
			* View historical profile details for the selected profile. Set the historyProfileId, deployEndDateTime,
			* and viewHistoryDetails. Then add the deployEndDateTime to the URL.
			* @param {Object} payload - historical profile object with the fields: priofileId and deployEndDateTime
			*/
			viewDetails(payload) {
				this.historyProfileId = payload.profileId;
				this.deployEndDateTime = payload.deployEndDateTime;
				let deployEnd = payload.deployEndDateTime.replace(" ", "_");
				this.viewHistoryDetails = true;

				// add deployEndDateTime to the URL
				this.$router.push({name: "Configuration History", params: {id: payload.profileId, deployEndDateTime: deployEnd}});
				
			},
			/**
			* Return to the historical profile data table. Clear the profile performance, set viewHistoryDetails to false,
			* and push the Configuration History path onto the router.
			*/
			backToProfileHistory() {
				this.$store.dispatch("clearProfilePerformance");
				this.viewHistoryDetails = false;
				this.$router.push({name: "Configuration History"});
			},
			/**
			* Replace the underscore with a space in the deployEndDateTime
			* @param {String} deployEndDateTime - last active date for the historical profile
			*/
			parseLastActive(deployEndDateTime) {
				let endDate = deployEndDateTime.replace("_", " ");

				this.deployEndDateTime = endDate;
			},
			/**
			* View initial decision meta data. Set the initial decision meta data in the config store, viewInitialDecisionDetails to true,
			* and push the Configuration Factors & Decisions path onto the router. 
			* @param {Object} decision - initial decision object
			*/
			viewInitialDecision(decision) {
				// set the initial decision in the config store
				this.$store.dispatch("setInitialDecisionMetaDataDetails", decision);
				this.viewInitialDecisionDetails = true;
				this.$router.push({name: "Configuration Factors & Decisions", params: {type: "decision", id: decision.initialDecisionConfigId}});
			},
			/**
			* Return to the initial decision pool. Set viewInitialDecisionDetails to false and push the Configuration Factors & Decisions
			* path onto the router without any parameters.
			*/
			backToInitialDecisionPool() {
				this.viewInitialDecisionDetails = false;
				this.$router.push({name: "Configuration Factors & Decisions"});
			},
			/**
			* View factor meta data. Set the factor meta data in the config store, viewFactorDetails to true,
			* and push the Configuration Factors & Decisions path onto the router. 
			* @param {Object} factor - factor object
			*/
			viewFactor(factor) {
				// set evaluation factor in the config store
				this.$store.dispatch("setFactorMetaDataDetails", factor);
				this.viewFactorDetails = true;
				this.$router.push({name: "Configuration Factors & Decisions", params: {type: "factor", id: factor.factorId}});
			},
			/**
			* Return to the evaluation factor pool. Set viewFactorDetails to false and push the Configuration Factors & Decisions
			* path onto the router without any parameters.
			*/
			backToEvaluationFactorPool() {
				this.viewFactorDetails = false;
				this.$router.push({name: "Configuration Factors & Decisions"});
			},
		},
	};
</script>

<!-- Page-Specific Style Import (don't edit here) -->
<style lang="scss">
	@import "@/design/views/configuration.scss";
</style>
